import React, { useEffect, useState } from 'react';
import TagManager from 'react-gtm-module';
import { Link } from 'react-router-dom';

import { btag, Bus, pushToDataLayer, SiteConfigManager, StorageManager } from '@atlas/core';
import { Button, Label } from '@atlas/ui';

import { BASE_PATH, COOKIES_ACCEPTED_EVENT } from 'common/constants';
import { isLocalEnv, LocalConfig } from 'common/utils';
import { hasCustomGTM, initCustomGTM } from 'src/helpers/initCustomGTM';
import useHotjar from 'src/hooks/useHotjar';
import useMetaPixel from 'src/hooks/useMetaPixel';

const isCookiesAllowedKey = 'isCookiesAllowed';

const Cookies = () => {
  const [isCookiesAllowed, setIsCookiesAllowed] = useState(
    StorageManager.getItem(isCookiesAllowedKey),
  );
  const projectId = LocalConfig.get('projectId');

  const { initHotjar } = useHotjar();
  const { initMetaPixel } = useMetaPixel();

  useEffect(() => {
    // if isCookiesAllowed comes from local storage it will have value 'true' or 'false'
    if (isCookiesAllowed === 'true') {
      if (!isLocalEnv && !hasCustomGTM(projectId)) {
        TagManager.initialize({
          gtmId: SiteConfigManager.getConfig('config.config.GTM'),
        });
      }

      pushToDataLayer('homepage', btag);

      if (hasCustomGTM(projectId) && !isLocalEnv) {
        initCustomGTM(projectId);
      }

      if (String(projectId) === '296') {
        initMetaPixel(488782233535872);
      }
    }

    initHotjar();
  }, [isCookiesAllowed, initHotjar, projectId, initMetaPixel]);

  const onSetIsCookiesAllowed = isCookiesActive => {
    StorageManager.setItem(isCookiesAllowedKey, isCookiesActive);
    setIsCookiesAllowed(isCookiesActive);
  };

  const onAllowCookies = () => {
    onSetIsCookiesAllowed('true');
    Bus.emit(COOKIES_ACCEPTED_EVENT);
  };

  const onDeclineCookies = () => {
    onSetIsCookiesAllowed('false');
  };

  // if isCookiesAllowed haven't defined
  if (isCookiesAllowed === null) {
    return (
      <div className="cookies">
        <div className="cookies__col">
          <div className="cookies__box">
            <img alt="cookies" loading="lazy" src={`${BASE_PATH}/static/assets/svg/cookies.svg`} />
          </div>

          <div className="cookies__inner">
            <Label className="cookies__title" message="cookies" />

            <div className="cookies__text">
              <Label message="cookies_we_use" />
              <Link to="/page/privacy-and-policy">
                <Label message="cookies" />
              </Link>
              <Label message="cookies_in_order" />
            </div>
          </div>
        </div>

        <div className="cookies__col right">
          <Button className="secondary" onClick={onDeclineCookies}>
            <Label message="cookies_decline" />
          </Button>

          <Button className="primary" onClick={onAllowCookies}>
            <Label message="cookies_accept" />
          </Button>
        </div>
      </div>
    );
  }

  return null;
};

export default Cookies;
